import '@innovatrics/dot-multi-range-liveness';
import type { Configuration, HTMLMultiRangeLivenessElement } from '@innovatrics/dot-multi-range-liveness';

import { memo, useEffect } from 'react';

const ELEMENT_ID = 'x-dot-multi-range-liveness';

const MultiRangeCameraInner = (props: Configuration) => {
  useEffect(() => {
    const el = document.getElementById(ELEMENT_ID) as HTMLMultiRangeLivenessElement | null;

    if (el) {
      el.configuration = props;
    }
  });

  return <x-dot-multi-range-liveness id={ELEMENT_ID} />;
};

export const MultiRangeCamera = memo(MultiRangeCameraInner);
